import { PackageOnCard } from '@/slw/entities/package';
import { Skeleton } from '@/slw/shared/ui/skeleton';

import { PricingCard } from './package-card.ui';

export function RegularPackagesSection({ packages, isLoading }: { packages: PackageOnCard[]; isLoading: boolean }) {
  if (isLoading) {
    return (
      <div className='grid grid-cols-1 md:grid-cols-3 gap-6 mb-20'>
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className='h-[25rem] w-full' />
        ))}
      </div>
    );
  }

  return (
    <div className='grid grid-cols-1 md:grid-cols-3 gap-6 mb-20'>
      {packages.map((packagePlan, index) => (
        <PricingCard
          key={packagePlan.id}
          packagePlan={packagePlan}
          // Delay animation based on index
          delay={index * 0.2}
        />
      ))}
    </div>
  );
}
